"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectStore = exports.SettingsInteractionsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var SettingsInteractionsActionTypes = (0, _namespacedKeyMirror.default)({
  SELECT_STORE: null
}, 'ecommerce-settings-interactions');
exports.SettingsInteractionsActionTypes = SettingsInteractionsActionTypes;
var selectStore = (0, _fluxActions.createAction)(SettingsInteractionsActionTypes.SELECT_STORE, function (storeToken) {
  return storeToken;
});
exports.selectStore = selectStore;